import React, { useEffect, useState } from "react";
import { Box, Flex, Image, Spinner, Text } from "@chakra-ui/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AppBar, APP } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { DOCUMENT_TYPE } from "./trainingConstants";
import { getTrainingDocumentViewLinkApi } from "../../api/training.api";

const MUTED = "#94A3B8";

const Centered = ({ children }) => (
  <Flex direction="column" align="center" justify="center" h="100%" px="24px" gap="10px">
    {children}
  </Flex>
);

// Trình xem tài liệu ngay trong trang (không mở tab mới -> không lộ signed URL
// trên thanh địa chỉ). PDF/ảnh/audio/video hiển thị trực tiếp bằng thẻ tương ứng.
const DocumentViewer = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { lessonId, attachmentId } = useParams();
  const [search] = useSearchParams();
  const name = search.get("name") || "Tài liệu";
  const type = search.get("type") || DOCUMENT_TYPE.OTHER;

  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!lessonId || !attachmentId) {
      setError("Thiếu thông tin tài liệu");
      return;
    }
    let cancelled = false;
    getTrainingDocumentViewLinkApi(lessonId, attachmentId)
      .then((data) => {
        if (cancelled) return;
        const signed = data?.url || (typeof data === "string" ? data : null);
        if (signed) setUrl(signed);
        else setError("Không lấy được tài liệu");
      })
      .catch((e) => {
        if (!cancelled) setError(e?.message || "Không lấy được tài liệu");
      });
    return () => {
      cancelled = true;
    };
  }, [lessonId, attachmentId]);

  const renderBody = () => {
    if (error) {
      return (
        <Centered>
          <Text fontSize="14px" color={MUTED} textAlign="center">
            {error}
          </Text>
        </Centered>
      );
    }
    if (!url) {
      return (
        <Centered>
          <Spinner color={APP.primary200} />
        </Centered>
      );
    }

    switch (type) {
      case DOCUMENT_TYPE.IMAGE:
        return (
          <Box h="100%" bg="#000">
            <Image src={url} alt={name} w="100%" h="100%" objectFit="contain" />
          </Box>
        );
      case DOCUMENT_TYPE.MP3:
        return (
          <Centered>
            <Text
              fontSize="15px"
              fontWeight={600}
              color="#08142D"
              textAlign="center"
              mb="8px"
            >
              {name}
            </Text>
            <audio controls src={url} style={{ width: "100%" }} />
          </Centered>
        );
      case DOCUMENT_TYPE.MP4:
        return (
          <Box h="100%" bg="#000">
            <video
              controls
              src={url}
              style={{ width: "100%", height: "100%", background: "#000" }}
            />
          </Box>
        );
      // PDF / DOCX / LINK / OTHER -> nhúng iframe (trình duyệt tự render PDF).
      default:
        return (
          <iframe
            title={name}
            src={url}
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        );
    }
  };

  const pageBody = (
    <>
      <Box
        h={{ base: "calc(100vh - 56px)", md: "calc(100vh - 120px)" }}
        bg="#525659"
      >
        {renderBody()}
      </Box>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title={name} right={<DesktopBack onClick={() => navigate(-1)} />}>
        <DesktopPanel p="0" pb="24px">
          {pageBody}
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto">
      <AppBar title={name} />
      {pageBody}
    </Box>
  );
};

export default DocumentViewer;
